<template>
  <div class="wrapper">
    <side-bar>
      <div class="folder-btn" v-if="isAdmin">
        <el-button type="primary" icon="el-icon-plus" size="small" @click="createFolder()" :style="`width:100%`">New
          Folder</el-button>
      </div>
      <div class="folder-btn" v-if="isAdmin">
        <el-button v-if="hasChanges" type="success" icon="el-icon-check" size="small" @click="saveFolders()"
          :style="`width:100%`">Save Changes</el-button>
      </div>
      <base-input group v-show="isAddingFolder">
        <div class="input-group">
          <input type="text" class="form-control ml-3 folder-input" placeholder="Folder name..."
            aria-label="Folder name" aria-describedby="button-addon" v-model="folder_name"
            v-on:keyup.enter="addFolder()" />
          <div class="input-group-append">
            <el-button class="btn btn-outline-danger mr-3" type="button" size="mini" id="button-addon"
              @click.stop="cancelAddFolder()">
              <!-- <i class="fas fa-check"></i> -->
              <i class="fas fa-times"></i>
            </el-button>
          </div>
        </div>
      </base-input>

      <template slot-scope="props" slot="links">
        <!-- <sidebar-item
          :link="{
            name: 'Dashboards',
            icon: 'ni ni-tv-2 text-primary'
          }"
        >
          <sidebar-item
            :link="{ name: 'Overview', path: '/dashboard' }"
          ></sidebar-item>
        </sidebar-item> -->

        <el-tree :data="folders" node-key="id" default-expand-all @node-drag-start="handleDragStart"
          @node-drag-enter="handleDragEnter" @node-drag-leave="handleDragLeave" @node-drag-over="handleDragOver"
          @node-drag-end="handleDragEnd" @node-drop="handleDrop" @node-click="handleClick" draggable
          :allow-drop="allowDrop" :allow-drag="allowDrag">
          <span class="custom-tree-node" :class="{ folder: !data.isBoard, 'padding-left-10': !isAdmin }"
            slot-scope="{ node, data }">
            <span>
              <el-button v-if="!data.isBoard && isAdmin" type="text" class="pl-2 pr-2"
                @click.stop="() => editFolder(node, data)">
                <i class="fas fa-pen"></i>
              </el-button>

              <el-button v-if="!data.isBoard && data.children.length == 0" type="text" class="pl-2 pr-2"
                @click.stop="() => deleteFolder(node, data)">
                <i class="fas fa-times"></i>
              </el-button>
            </span>

            <input type="text" class="folder-input" v-if="data.isEditing" v-model="data.label"
              v-on:keyup.enter="saveFolderName(data, data.label)" v-on:click.stop />
            <span v-else :class="{ active: data.id == activeId }">{{
        data.label
      }}</span>
          </span>
        </el-tree>

        <!-- <sidebar-item
          :expand="true"
          :link="{
            name: 'Boards',
            icon: 'ni ni-bullet-list-67 text-primary'
          }"
        >
          <template v-for="board in boards">
            <sidebar-item
              :key="board.id"
              :link="{
                name: board.name,
                path: '/board/' + board.id,
                title: board.name
              }"
            />
          </template>
</sidebar-item> -->

        <sidebar-item v-if="isAdmin" :link="{
        name: 'Manage Users',
        icon: 'ni ni-single-02 text-primary',
        path: '/manage-users',
      }">
        </sidebar-item>
      </template>

      <template slot="links-after">
        <hr class="my-3" />
        <h6 class="navbar-heading p-0 text-muted">Need help?</h6>

        <ul class="navbar-nav mb-md-3">
          <li class="nav-item">
            <a class="nav-link" href="https://simplysakal.asia/contact/" target="_blank">
              <i class="ni ni-send"></i>
              <span class="nav-link-text">Contact Us</span>
            </a>
          </li>
        </ul>
      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType" :name="$route.name"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import router from "@/routes/router";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}
import store from "@/store";
import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import { FadeTransition } from "vue2-transitions";
import { Button, Tree } from "element-ui";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    DashboardContent,
    FadeTransition,
    [Button.name]: Button,
    [Tree.name]: Tree,
  },
  data() {
    return {
      boards: [],
      isAdmin: false,
      isAddingFolder: false,
      isEditing: false,
      hasChanges: false,
      folder_name: "",
      defaultProps: {
        label: "label",
        children: "children",
      },
      folders: [],
      activeId: null,
    };
  },
  methods: {
    initScrollbar() {
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("sidenav");
      }
    },
    createFolder() {
      this.isAddingFolder = true;
    },
    addFolder() {
      if (this.folder_name.length <= 0) return;
      this.folders.unshift({
        label: this.folder_name,
        children: [],
        isEditing: false,
      });
      this.isAddingFolder = false;
      this.folder_name = "";
      this.hasChanges = true;
    },
    editFolder(node, data) {
      data.isEditing = true;
    },
    deleteFolder(node, data) {
      this.folders = _.filter(
        this.folders,
        (f) => f.$treeNodeId != data.$treeNodeId
      );
      this.hasChanges = true;
    },
    cancelAddFolder() {
      this.isAddingFolder = false;
    },
    saveFolderName(data, nodeName) {
      data.isEditing = false;
      data.label = nodeName;
      this.hasChanges = true;
    },
    saveFolders() {
      // save to db
      store.dispatch("user/save_folders", this.folders).then(() => {
        this.hasChanges = false;
      });
    },
    loadFolders() {
      // fetch from db
      return store.dispatch("user/get_folders");
    },
    handleDragStart(node, ev) {
      // console.log("drag start", node);
    },
    handleDragEnter(draggingNode, dropNode, ev) {
      // console.log("tree drag enter: ", dropNode.label);
    },
    handleDragLeave(draggingNode, dropNode, ev) {
      // console.log("tree drag leave: ", dropNode.label);
    },
    handleDragOver(draggingNode, dropNode, ev) {
      // console.log("tree drag over: ", dropNode.label);
    },
    handleDragEnd(draggingNode, dropNode, dropType, ev) {
      // console.log("tree drag end: ", dropNode && dropNode.label, dropType);
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
      // console.log("tree drop: ", dropNode.label, dropType);
    },
    handleClick(node, prop, treeNode) {
      if (node.isEditing) return false;
      this.activeId = node.id;

      if (node.isBoard) {
        router.push({
          path: `/board/${node.id}`,
        });
      }
    },
    allowDrop(draggingNode, dropNode, type) {
      // prevent board drop into board
      if (
        dropNode.data.isBoard &&
        type == "inner"
      ) {
        return false;
      }

      // prevent folder drop into folder
      if (
        !draggingNode.data.isBoard &&
        !dropNode.data.isBoard &&
        type == "inner"
      ) {
        return false;
      }

      // prevent folder drop into folder with boards
      if (
        !draggingNode.data.isBoard &&
        dropNode.data.isBoard &&
        dropNode.level > 1
      ) {
        return false;
      }

      this.hasChanges = true;
      return true;
    },
    allowDrag(draggingNode) {
      if (this.isAdmin) return true;
      return false;
    },
  },
  computed: {
    getBoards() {
      return store.state.monday.boards;
    },
  },
  mounted() {
    this.initScrollbar();

    this.isAdmin = store.state.user.me.account_type == "admin";

    store.dispatch("monday/list_boards").then(() => {
      this.boards = this.getBoards;

      this.loadFolders().then(() => {
        if (store.state.user.folders.length == 0) {
          // admin did not define a folder structure
          this.folders.push({
            label: "Boards",
            id: 1,
            children: [],
            isEditing: false,
          });
          this.boards.forEach((b) => {
            this.folders[0].children.push({
              label: b.name,
              id: b.id,
              isBoard: true,
            });
          });
        } else {
          // build folder structure for user
          // filter admin's folder list of boards with user's list of boards
          // because user may not have permissions to see all of admin's boards
          let all_folders = store.state.user.folders; // admin's predefined folder structure
          let ids = this.boards.map((b) => b.id); // user's board ids
          // console.log("user board ids = ", ids);
          let user_folders = [];

          // find folder in admin's predefined folder structure
          all_folders.map((folder) => {
            // for folders with children
            if (folder.children && folder.children.length > 0) {
              let arr = folder.children.filter((f) => {
                return ids.includes(f.id);
              });
              if (arr.length > 0) {
                // replace board name in arr with user's board name
                // board names may have changed since folders were created
                arr.map((a) => {
                  a.label = this.boards.find((b) => b.id == a.id).name;
                  ids = ids.filter((i) => i != a.id);
                });
                user_folders.push({
                  label: folder.label,
                  children: arr,
                  isEditing: false,
                });
              }
            } else {
              // for folders without children
              if (ids.includes(folder.id)) {
                folder.label = this.boards.find((b) => b.id == folder.id).name;
                user_folders.push(folder);
              }
            }
          });

          // find list of boards that are not assigned a folder (ie. newly added boards)
          this.boards.map((b) => {
            if (
              ids.includes(b.id) &&
              user_folders.findIndex((f) => f.id == b.id) < 0
            ) {
              user_folders.push({
                label: b.name,
                id: b.id,
                isBoard: true,
              });
            }
          });

          this.folders = user_folders;

          // redirect to the first board
          let first_board = this.folders.find((folder) => {
            return (
              folder.isBoard || (folder.children && folder.children.length > 0)
            );
          });

          // first board is a folder, so we set it to its first child
          if (first_board.children && first_board.children.length > 0) {
            first_board = first_board.children[0];
          }

          if (router.currentRoute && !router.currentRoute.params.id) {
            this.activeId = first_board.id;
            router.push({
              path: `/board/${first_board.id}`,
            });
          } else this.activeId = router.currentRoute.params.id;
        }
      });
    });
  },
};
</script>
<style lang="scss">
.fa-pen {
  color: #fff;
}

.active {
  color: rgb(51, 170, 219);
}

.el-tree {
  background-color: transparent;
  color: #fff;
}

.el-tree-node__content:hover,
.el-tree-node__content:focus,
.el-tree-node__content:active {
  background-color: transparent;
  /* color: rgb(51, 170, 219); */
  color: #fff;
}

.el-tree-node__content {
  height: 32px;
  font-size: 13px;
}

.el-tree-node__content:has(.folder) {
  overflow: hidden;
}

.el-tree-node:focus>.el-tree-node__content {
  background-color: #222;
  color: #fff;
}

.folder {
  font-size: 16px;
  font-weight: 700;
  // color: rgb(51, 170, 219);

  background-color: rgb(51, 170, 219);

  display: flex;
  flex: 1;

  height: 100%;

  align-items: center;

  margin: 0 10px 0 0;

  &:active,
  &:focus {
    background-color: transparent;
  }

  .active {
    color: #fff;
  }
}

.folder-input {
  background-color: transparent;
  color: #fff;
  border: 1px solid #fff;
}

button:focus {
  outline: none;
}

.folder-btn {
  display: block;
  margin: 0 15px 15px 15px;
}

// hide scrollbars from sidenav
// .el-tree-node__content::-webkit-scrollbar {
//   display: none;
// }
.navbar-vertical.navbar-expand-xs::-webkit-scrollbar {
  display: none;
}

.padding-left-10 {
  padding-left: 10px;
}
</style>
